export enum ProfilingCodeType {
  Accreditation = 'Accreditation',
  Campaigns = 'Campaigns',
  Program = 'Program',
  Tools = 'Tools',
  UserRights = 'UserRights',
  Agreement = 'Agreement',
}

export type ProfilingCode = {
  entryId: string
  code: string
  type: ProfilingCodeType
  roles: string
  codeName: string
  geoMarket: string
  users: string
  countries: string
}

export type ProfilingCodeOptions = {
  [key in ProfilingCodeType]: Array<ProfilingCode>
}
